import { Module } from "@/generated/api/farmManagement";

type FarmModule = Module;

type FarmModuleSettings = Record<FarmModule, boolean>;

/**
 * Readable aliases for the generated `Module` enum — its members come out of
 * Orval with the dots stripped (`mapthematic_maps`), so they don't read at call
 * sites. `satisfies` pins every value to the API enum.
 */
const FARM_MODULES = {
  MAP_LAYERS: "map.layers",
  MAP_PARCELS: "map.parcels",
  MAP_THEMATIC_MAPS: "map.thematic_maps",
  MAP_TELEMATICS: "map.telematics",
  PRECISION_FARMING: "precision_farming",
  PRECISION_FARMING_MACHINE_DATA: "precision_farming.machine_data",
  PRECISION_FARMING_PRESCRIPTION_MAPS: "precision_farming.prescription_maps",
  TELEMATICS: "telematics",
  IRRIGATION: "irrigation",
  ACTIVITIES: "activities",
  STORES: "stores",
  REPORTS: "reports",
  CATALOGUES: "catalogues",
} as const satisfies Record<string, FarmModule>;

const FARM_MODULE_KEYS: readonly string[] = Object.values(Module);

const isFarmModule = (key: string): key is FarmModule =>
  FARM_MODULE_KEYS.includes(key);

const toFarmModuleSettings = (
  disabledModules: readonly FarmModule[],
): FarmModuleSettings =>
  Object.fromEntries(
    Object.values(Module).map((module) => [
      module,
      !disabledModules.includes(module),
    ]),
  ) as FarmModuleSettings;

const ALL_FARM_MODULES_ENABLED = toFarmModuleSettings([]);

export {
  ALL_FARM_MODULES_ENABLED,
  FARM_MODULES,
  isFarmModule,
  toFarmModuleSettings,
};
export type { FarmModule, FarmModuleSettings };
